import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import {
  ActionsMenuLayout,
  Text,
  SocialBar,
  MobileDrawer,
  MobileDrawerPosition,
} from '..';

import {
  CloseSmall,
  Facebook,
  Instagram,
  LikeHeart,
  LinkedIn,
  Tumblr,
  VideoFillSmall,
} from '@wix/wix-ui-icons-common/on-stage';
import { EditorShell } from '../../test/visual/VisualAsync';
import { classes } from './MobileDrawer.visual.st.css';
import classnames from 'classnames';

const MobileDrawerTest = (props) => {
  return (
    <MobileDrawer
      isOpen
      className={classnames({
        [classes.borderRadius]: props.borderRadius,
        [classes.borderColorAndWidth]: props.borderColorAndWidth,
        [classes.borderColorWidthAndOpacity]: props.borderColorWidthAndOpacity,
        [classes.backgroundOpacity]: props.backgroundOpacity,
        [classes.combinedOverrides]: props.combinedOverrides,
        [classes.wstColors]: props.wstColors,
        [classes.borderWidth]: props.borderWidth,
      })}
      {...props}
    >
      {props.children || <div className={classes.fill}>This is the content!</div>}
    </MobileDrawer>
  );
};

visualize('MobileDrawer', () => {
  story('Basic', () => {
    snap(`With Action Menu`, () => (
      <EditorShell>
        <MobileDrawer isOpen>
          <div className={classes.actionMenuContainer}>
            <ActionsMenuLayout>
              <ActionsMenuLayout.Item
                onClick={() => console.log('Video clicked')}
                content="Take a Video"
                prefixIcon={<VideoFillSmall />}
              />
              <ActionsMenuLayout.Item
                onClick={() => console.log('Picture clicked')}
                content="Take a Picture"
                prefixIcon={<LikeHeart />}
              />
              <ActionsMenuLayout.Divider />
              <ActionsMenuLayout.Item
                onClick={() => {}}
                content="Close"
                prefixIcon={<CloseSmall />}
              />
            </ActionsMenuLayout>
          </div>
        </MobileDrawer>
      </EditorShell>
    ));
    snap('With Social Bar', () => (
      <MobileDrawer isOpen>
        <div className={classes.socialBarContainer}>
          <Text>Share</Text>
          <SocialBar>
            <SocialBar.Icon icon={<Facebook />} />
            <SocialBar.Icon icon={<Instagram />} />
            <SocialBar.Icon icon={<LinkedIn />} />
            <SocialBar.Icon icon={<Tumblr />} />
          </SocialBar>
        </div>
      </MobileDrawer>
    ));
    snap('With Simple Text', () => (
      <MobileDrawer isOpen>Children</MobileDrawer>
    ));
    snap('With Position Top', () => (
      <MobileDrawerTest position={MobileDrawerPosition.Top} />
    ));
    snap('With FullScreen', () => (
      <MobileDrawerTest
        isFullScreen
        children={<div className={classes.fullScreenContent}>This is the content!</div>}
      />
    ));
    snap('With WST Colors', () => (
      <MobileDrawerTest position={MobileDrawerPosition.Top} wstColors />
    ));
  });

  story('CSS Variable Overrides', () => {
    snap('border width', <MobileDrawerTest borderWidth />);
    snap('border color and width', <MobileDrawerTest borderColorAndWidth />);
    snap('border color, width and opacity', <MobileDrawerTest borderColorWidthAndOpacity />);
    snap('background color and opacity', <MobileDrawerTest backgroundOpacity />);
    snap('combined overrides', <MobileDrawerTest combinedOverrides />);
    snap('rounded corners', <MobileDrawerTest borderRadius />);
    snap('rounded corners for Top position', (
      <MobileDrawerTest borderRadius position={MobileDrawerPosition.Top} />
    ));
  });

  story('appendToBody', () => {
    snap('with CSS overrides and appendToBody', (
      <MobileDrawerTest appendToBody combinedOverrides />
    ));
  });
});
